/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class ContactFlowEnrollmentsAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  index(contactId) {
    return axios.get(`${this.url}/${contactId}/flow_enrollments`);
  }

  create(contactId, flowId) {
    return axios.post(`${this.url}/${contactId}/flow_enrollments`, {
      flow_id: flowId,
    });
  }

  destroy(contactId, flowId) {
    return axios.delete(`${this.url}/${contactId}/flow_enrollments/${flowId}`);
  }
}

export default new ContactFlowEnrollmentsAPI();
